import {ajaxProjectUpdate, ajaxRequest} from "./Ajax";
import Helper from "./Helper";
import Api from "./Api";


export async function popupEditWork(rowData) {

    const commentResponse = await Api.loadComment(rowData.id);
    const commentObj = commentResponse?.success ? commentResponse.data : [];
    const hoursAndMinute = ESR.Helper.fromDecimalHours(rowData?.hours);

    let initValues = {
        date: rowData?.date ? ESR.Helper.formatDate(rowData.date) : '',
        qty: Number(rowData?.qty) ?? '',
        hours: hoursAndMinute[0] ?? '',
        minutes: hoursAndMinute[1] ?? '',
        worker_ids: rowData.workers.map(item => item.id),
        comment_text: commentObj?.comment ?? ''
    }

    const getOptionsWorkers = () => {
        const options = [...ESR.workers];

        rowData.workers.forEach(item => {
            if (!options.some(option => option.value === item.id)) {
                options.push({
                    value: item.id,
                    label: item.name || `User ${item.id}`
                });
            }
        });

        return options;
    };


    const fieldConfigs = [
        {
            id: 'sw-input-date',
            label: {text: ESR.lang.date},
            input: {type: 'text', name: 'date', value: initValues.date, required: true},
            wrapper: {class: 'form-control form-control-date col-span-12'},
            errors: {
                required: 'Cîmpul Data este obligatoriu.',
            }
        },
        {
            id: 'sw-input-qty',
            label: {text: ESR.lang.qty, altText: initValues.unit},
            input: {
                type: 'number',
                name: 'qty',
                value: initValues.qty,
                required: true,
                pattern: '(0\\.(0[1-9]|[1-9]\\d*)|[1-9]\\d*(\\.\\d+)?)',
            },
            wrapper: {class: 'form-control form-control-vol col-span-6'},
            errors: {
                required: 'Cîmpul Volum este obligatoriu.',
                pattern: 'Cîmpul Volum trebuie se fie un număr, ex. 100 sau 100.80'
            }
        },
        {
            id: 'sw-input-hours',
            label: {text: 'Ore'},
            input: {type: 'number', name: 'hours', value: initValues.hours, inputmode: 'numeric', min: 0},
            wrapper: {class: 'form-control form-control-hours col-span-3'}
        },
        {
            id: 'sw-input-minutes',
            label: {text: 'Minute'},
            input: {
                type: 'number',
                name: 'minutes',
                value: initValues.minutes,
                inputmode: 'numeric',
                min: 0
            },
            wrapper: {class: 'form-control form-control-vol col-span-3'},
        },
        {
            id: 'sw-input-workers',
            label: {text: ESR.lang.workers},
            input: {
                type: 'select',
                name: 'worker_ids',
                value: initValues.worker_ids,
                multiple: 1,
                options: getOptionsWorkers(),
                required: true,
            },
            wrapper: {class: 'form-control form-control-workers col-span-12'},
        },
        {
            id: 'sw-input-comment-text',
            label: {text: 'Comentariu'},
            input: {
                type: 'textarea',
                name: 'comment_text',
                value: initValues?.comment_text,
                rows: 3,
                class: 'textarea input-bordered',
            },
            wrapper: {class: 'form-control form-control-comment col-span-12'}
        },
    ];

    const popupHtml = $('<div class="esr-popup-fields grid grid-cols-12 gap-4"></div>')
        .append(`<div class="col-span-12 text-left"> #${rowData.id} - ${rowData.service_title}</div>`)

    fieldConfigs.forEach(config => {
        popupHtml.append(ESR.View.field(
            config.id,
            config.label,
            config.input,
            config.wrapper
        ));
    });


    return ESR.Popup.fire({
        title: 'Editează',
        html: popupHtml,
        showCloseButton: true,
        confirmButtonText: ESR.lang.update,
        showLoaderOnConfirm: true,
        didOpen: () => {
            $('#sw-input-date').attr('value', initValues.date).datepicker({
                language: 'ro',
                todayBtn: true,
                autoclose: true,
                endDate: new Date(),
                format: 'yyyy mm dd'
            })

            // Initialize select2 with dropdownParent set to the Swal modal container
            $('#sw-input-workers').select2({
                dropdownParent: $('.swal2-container') // Ensures dropdown is within the SweetAlert modal
            });
        },
        preConfirm: async () => {

            const elInputDate = $('#sw-input-date');
            const elInputVol = $('#sw-input-qty');
            const elInputHours = $('#sw-input-hours');
            const elInputMinute = $('#sw-input-minutes');
            const elInputWorkers = $('#sw-input-workers');
            const elInputCommentText = $('#sw-input-comment-text');

            const formData = {
                date: elInputDate.val(),
                qty: Number(elInputVol.val()),
                minutes: Number(elInputMinute.val()),
                hours: Number(elInputHours.val()),
                worker_ids: elInputWorkers.val(),
                comment_text: elInputCommentText.val()
            }

            let diffData = ESR.Helper.deepDiff(initValues, formData);

            if(formData.comment_text !== '') {
                diffData.comment_text = formData.comment_text;
            }

            if (!diffData) {
                Swal.showValidationMessage('Nu sunt actualizări de efectuat.');
                return false;
            }

            if (diffData?.hours || diffData?.minutes) {
                diffData.hours = ESR.Helper.toDecimalHours(formData.hours, formData.minutes)

                if (diffData?.hours <= 0) {
                    Swal.showValidationMessage('Ore sau Minute trebuie să fie completat.');
                    return false;
                }
            }

            if (diffData?.worker_ids && ESR.Helper.isEmpty(diffData?.worker_ids)) {
                Swal.showValidationMessage('Selectați cel puțin un angajat');
                return false;
            }

            if ( diffData?.date && !ESR.Helper.validateDate(diffData.date)) {
                Swal.showValidationMessage('Data nu este validă, formatul acceptat ' + ESR.Helper.formatDate(new Date()));
                return false;
            }


            await ajaxRequest({
                action: "esr_update_work",
                data: {
                    id: rowData.id,
                    comment_id: commentObj?.id ?? 0,
                    modified_by: ESR.user.id,
                    ...diffData
                }
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
    })
}


export function popupCreateUpdateUser(rowData = {}) {

    const isEditMode = rowData?.id ? true : false;
    const row_user_id = rowData?.id;
    const popupTitle = isEditMode ? 'Editează Obiectiv' : 'Adaugă Obiectiv';

    const popupHtml = $('<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>');

    const optionsUserRoles = Object.entries(ESR.user_roles).map(([value, label]) => ({value, label}));

    const initValues = {
        name: rowData?.name ?? '',
        email: rowData?.email ?? '',
        phone: rowData?.phone ?? '',
        job_title: rowData?.job_title ?? '',
        coef: rowData?.coef ?? 1,
        role: rowData?.role?.value ?? 'worker'
    }

    const fieldConfigs = [
        {
            id: 'sw-input-name',
            label: {text: ESR.lang.user_name},
            input: {type: 'text', name: 'display_name', value: initValues.name, required: true},
            wrapper: {class: 'form-control col-span-2'}
        },
        {
            id: 'sw-input-job',
            label: {text: 'Funcție'},
            input: {type: 'text', name: 'job_title', value: initValues.job_title},
            wrapper: {class: 'form-control col-span-2'}
        },
        {
            id: 'sw-input-email',
            label: {text: ESR.lang.email},
            input: {type: 'email', name: 'email', value: initValues.email},
            wrapper: {class: 'form-control col-span-2'}
        },
        {
            id: 'sw-input-phone',
            label: {text: ESR.lang.phone_number},
            input: {type: 'text', name: 'phone', value: initValues.phone},
            wrapper: {class: 'form-control col-span-2'}
        },
        {
            id: 'sw-input-coef',
            label: {text: ESR.lang.coefficient},
            input: {type: 'number', name: 'coef', value: initValues.coef},
            wrapper: {}
        },
        {
            id: 'sw-input-role',
            label: {text: 'Rol și Acces'},
            input: {type: 'select', name: 'role', value: initValues.role, options: optionsUserRoles},
            wrapper: {}
        }
    ];

    fieldConfigs.forEach(config => {
        popupHtml.append(ESR.View.field(
            config.id,
            config.label,
            config.input,
            config.wrapper
        ));
    });

    const enableButtonOnInput = () => {
        Swal.getConfirmButton().disabled = true;

        const inputs = Swal.getHtmlContainer().querySelectorAll('input, select');

        inputs.forEach(input => {
            input.addEventListener('input', () => {
                Swal.getConfirmButton().disabled = !validateRequiredFields();
            });
        });
    };

    const validateRequiredFields = () => {
        const popupFields = $('.esr-popup-fields');
        const name = popupFields.find('[name="display_name"]').val();
        const email = ESR.Helper.validateEmail(popupFields.find('[name="email"]').val());
        const job_title = popupFields.find('[name="job_title"]').val();

        if (isEditMode) {
            return name && job_title && email;
        } else {
            return name && job_title;
        }

        return true;
    };

    const getFormData = () => {
        const popupFields = $('.esr-popup-fields');
        const formData = {};

        fieldConfigs.forEach(field => {
            const input = popupFields.find(`[name="${field.input.name}"]`);
            formData[field.input.name] = input.val();
        });

        return formData;
    };

    return ESR.Popup.fire({
        popupTitle,
        html: popupHtml,
        showCloseButton: true,
        confirmButtonText: ESR.lang.save,
        showLoaderOnConfirm: true,
        willOpen: enableButtonOnInput,
        preConfirm: async () => {
            const formData = getFormData();
            let newData = {};

            if (isEditMode) {
                newData.user_id = row_user_id;

                // Pentru editare, adaugă doar câmpurile modificate
                Object.keys(formData).forEach(key => {
                    if (formData[key] !== initValues[key]) {
                        newData[key] = formData[key];
                    }
                });

                // Validare email pentru editare
                if (formData.email && !ESR.Helper.validateEmail(formData.email)) {
                    Swal.showValidationMessage("Adresa de email nu este validă");
                    return;
                }

                if (Object.keys(newData).length <= 1) { // Doar user_id
                    Swal.showValidationMessage("Nu s-au făcut modificări");
                    return;
                }

                console.log(newData)

                await ajaxRequest({action: "esr_update_user", data: newData});
            } else {
                newData = {...formData};

                if (!formData.name) {
                    Swal.showValidationMessage("Cîmpul Nume Prenume este obligatorii");
                    return;
                }

                await ajaxRequest({action: "esr_create_user", data: newData});
            }
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

// Function to handle common Swal popup logic (add/edit)
export function popupCreateUpdateProject(rowData = {}, confirmBtnText) {
    const canEditOther = ESR.Helper.userCan('edit_others_project');
    const isEditMode = rowData?.id ? true : false;
    let bodyHTML;
    let popupTitle = '';
    const rowManagerID = rowData?.manager?.id ??  0;
    const rowTitle = rowData?.post_title ?? '';
    const rowStatus = rowData?.status || 'publish';

    if (isEditMode) {
        // Check if a Manager tries to edit a project of another
        if (!canEditOther && parseInt(rowManagerID) !== parseInt(ESR.user.id)) {
            ESR.Popup.warning({
                html: `Mănagerul obiectivului este <b>${rowData.manager.name}</b>, Dvs. nu aveți permisiuni de editare.`,
                confirmButtonText: ESR.lang.close,
            });
            return;
        }
        popupTitle = 'Editează Obiectiv';
    } else {
        popupTitle = 'Adaugă Obiectiv';
    }

    const fieldTitle = ESR.View.field(
        'sw-input-title',
        {text: 'Denumire Obiectiv'},
        {'type': 'text', 'value': rowTitle}
    );

    let fieldManager = null;

    if (canEditOther) {
        fieldManager = ESR.View.field(
            'sw-input-manager',
            {text: 'Mănager'},
            {
                type: 'select',
                value: rowManagerID,
                placeholder: 'Selectează mănagerul',
                options: ESR?.managers
            }
        );
    } else {
        fieldManager = ESR.View.field(
            'sw-input-manager',
            {},
            {
                type: 'hidden',
                value: isEditMode ? rowManagerID : ESR.user.id
            }
        );
    }

    const fieldPostStatus = ESR.View.field(
        'sw-input-status',
        {text: ESR.lang.status},
        {
            type: 'select',
            value: rowStatus,
            options: [
                {value: 'publish', label: ESR.lang.status_publish},
                {value: 'finished', label: ESR.lang.status_finished}
            ]
        }
    );

    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-1 gap-4"></div>`);
    popupContent.append(fieldTitle)
    if (canEditOther) popupContent.append(fieldManager)
    popupContent.append(fieldPostStatus)

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        showLoaderOnConfirm: true,
        didOpen: () => {
            // $('#sw-input-manager').select2({
            //     dropdownParent: $('.swal2-container') // Ensures dropdown is within the SweetAlert modal
            // });
        },
        preConfirm: async () => {
            const elInputTitle = $('#sw-input-title');
            const elSelectManager = $('#sw-input-manager');
            const elSelectStatus = $('#sw-input-status');
            const title = elInputTitle.val().trim();
            const status = elSelectStatus?.val() ?? 'publish';
            const manager_id = canEditOther ? elSelectManager.val() : ESR.user.id;
            const post_id = rowData?.id;

            // Validate title input
            if (!title.length) {
                Swal.showValidationMessage('Completează denumire obiectiv');
                elInputTitle.focus();
                return;
            }

            // Validate manager selection
            if (!manager_id) {
                Swal.showValidationMessage(ESR.lang.completeProjectManager);
                if (canEditOther) elSelectManager.focus();
                return;
            }

            return await ajaxProjectUpdate({title, manager_id, post_id, status});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupCreateUpdateService(rowData = {}, confirmBtnText) {

    let popupTitle = 'Adaugă Serviciu';

    const id = rowData?.ID ?? 0;
    let service_title = '';
    let category_id = '';
    let price_a = '';
    let hours = '';
    let unit = '';
    let cod = '';
    let visibility = 1;

    if (id) {
        popupTitle = 'Editează Serviciu'
        service_title = rowData?.title
        category_id = rowData?.term_id
        price_a = rowData?.price_a
        hours = rowData?.hours
        unit = rowData?.unit
        cod = rowData?.cod
        visibility = rowData.visibility
    }

    const optionsCategorii = Object.entries(ESR.services_terms).map(item => ({
        value: item[0],
        label: item[1].term_name
    }));
    const optionsUnits = ESR.options.units.map(item => ({value: item, label: item}))

    const fieldTitle = ESR.View.field(
        'sw-input-title',
        {text: 'Denumire Serviciu'},
        {'type': 'text', 'value': service_title},
        {class: 'col-span-2'}
    );

    const fieldCategory = ESR.View.field(
        'sw-input-category',
        {text: 'Categorie'},
        {
            type: 'select',
            value: category_id,
            class: 'w-full',
            placeholder: 'Selectează categoria',
            options: optionsCategorii
        }
    );

    const fFieldUnit = ESR.View.field(
        'sw-input-unit',
        {text: 'Unitate'},
        {
            type: 'select',
            value: unit,
            options: optionsUnits
        }
    );

    const fFieldVisibility = ESR.View.field(
        'sw-input-visibility',
        {
            text: ESR.lang.visibility
        },
        {
            type: 'select',
            value: visibility,
            options: [
                {value: 'publish', label: ESR.lang.visible},
                {value: 'private', label: ESR.lang.hidden}
            ]
        }
    );

    const fieldPrice = ESR.View.field(
        'sw-input-price-a',
        {text: 'Preț (MDL)'},
        {'type': 'number', 'value': price_a}
    );

    const fieldHours = ESR.View.field(
        'sw-input-hours',
        {text: 'Ore'},
        {'type': 'number', 'value': hours}
    );

    const fieldCod = ESR.View.field(
        'sw-input-cod',
        {text: 'Cod'},
        {'type': 'text', 'value': cod}
    );

    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>`);

    popupContent.append(fieldTitle)

    //if is add new (not update)
    if (!id) popupContent.append(fieldCategory)

    popupContent.append(fieldCod)
    popupContent.append(fFieldUnit)
    popupContent.append(fieldHours)
    popupContent.append(fieldPrice)
    popupContent.append(fFieldVisibility)


    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {

            const elInputTitle = $('#sw-input-title');
            const elInputCategory = $('#sw-input-category');
            const elInputPriceA = $('#sw-input-price-a');
            const elInputHours = $('#sw-input-hours');
            const elInputCod = $('#sw-input-cod');
            const elInputUnit = $('#sw-input-unit');
            const elInputVisibility = $('#sw-input-visibility');

            const data = {
                post_id: id,
                title: elInputTitle.val().trim(),
                category_id: elInputCategory?.val(),
                price_a: elInputPriceA.val(),
                hours: elInputHours.val(),
                unit: elInputUnit.val(),
                cod: elInputCod.val(),
                status: elInputVisibility.val(),
            }

            if (!data.title.length) {
                Swal.showValidationMessage('Completează denumirea');
                elInputTitle.focus();
                return;
            }

            if (!id && !data.category_id?.length) {
                Swal.showValidationMessage('Completează categoria');
                elInputCategory.focus();
                return;
            }


            if (Helper.isEmpty(data.hours)) {
                Swal.showValidationMessage('Completează Ore');
                elInputHours.focus();
                return;
            }


            if (Helper.isEmpty(data.unit)) {
                Swal.showValidationMessage('Completează Unitate');
                elInputPriceA.focus();
                return;
            }

            console.log(data)
            return await ajaxRequest({action: "esr_update_service", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupCreateUpdateServiceCategory(rowData = {}, confirmBtnText) {

    const term_id = rowData?.term_id ?? 0;
    let popupTitle = 'Adaugă Categorie';
    let term_name = '';
    let visibility = 'true';

    if (term_id) {
        popupTitle = 'Editează Categoria'
        term_name = rowData?.term_name
        visibility = rowData.visibility
    }

    const fieldTitle = ESR.View.field(
        'sw-input-title',
        {text: 'Denumire Categorie'},
        {type: 'text', value: term_name}
    );

    const fFieldVisibility = ESR.View.field(
        'sw-input-visibility',
        {
            text: ESR.lang.visibility
        },
        {
            type: 'select',
            value: visibility,
            options: [
                {value: 'true', label: ESR.lang.visible},
                {value: 'false', label: ESR.lang.hidden}
            ]
        }
    );

    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-1 gap-4"></div>`);

    popupContent.append(fieldTitle)
    popupContent.append(fFieldVisibility)

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            const elInputTitle = $('#sw-input-title');
            const elInputVisibility = $('#sw-input-visibility');

            const data = {
                term_id,
                term_name: elInputTitle.val().trim(),
                visibility: elInputVisibility.val(),
            }

            if (!data.term_name.length) {
                Swal.showValidationMessage('Completează denumirea');
                elInputTitle.focus();
                return;
            }

            return await ajaxRequest({action: "esr_update_service_category", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupResetPassword(user_id, name) {
    ESR.Popup.fire({
        title: 'Resetare Parola',
        html: `Doriți să resetați parola lui <b>${name}</b> ?`,
        showCloseButton: true,
        confirmButtonText: 'Resetează',
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            return await ajaxRequest({action: "esr_reset_user_password", data: {user_id}});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}
